module.exports = __webpack_public_path__ + "img/photo-04-1.2f3d5f6f.png";